"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _actions = require("settings-ui-sdk/Products/actions");

var NONE = null;
var initialState = NONE;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actions.ProductActionTypes.EDIT_PRODUCT:
      return action.payload;

    case _actions.CreateProductActionTypes.SUCCESS:
    case _actions.CreateProductAndAddAnotherActionTypes.SUCCESS:
    case _actions.UpdateProductActionTypes.SUCCESS:
    case _actions.CreateProductActionTypes.FAILURE:
    case _actions.CreateProductAndAddAnotherActionTypes.FAILURE:
    case _actions.UpdateProductActionTypes.FAILURE:
      return NONE;

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;